import Axios from "axios";
import Cookies from "universal-cookie";
import SocketHelper from "../globalHelpers/SocketHelper";
const cookies = new Cookies();
const localRoute = "/private";
Axios.defaults.headers.common["Cache-Control"] = "no-cache";
const login = "Authentication";
const nonce = crypto.randomUUID();
let callingPrivateWebsocketPing = false;
let callingPublicWebsocketPing = false;
const websocketPingDurration = 500;
const websocketRetryLimit = 10;

class Express {
    constructor() {
        this.callbacks = {};
        this.publicCallbacks = {};
    }

    async call(functionName, parameters, callback) {
        return new Promise(async (resolve) => {
            try {
                const authenticationId =
                    window.localStorage.getItem("authenticationId");
                const requestId = crypto.randomUUID();

                if (!authenticationId) return;

                await this.validateSign();

                // encapsulate axios REST call and response into function
                // that is called after WebSocket connection is created
                const onResponse = () => {
                    SocketHelper.onResponse(
                        functionName,
                        requestId,
                        (results) => {
                            // results: decoded REST response returned via WebSocket
                            if (callback) callback(results);
                            resolve(results);
                        }
                    );

                    Axios.post(
                        localRoute,
                        {
                            serviceName: functionName,
                            parameters,
                        },
                        {
                            headers: {
                                "x-access-token":
                                    window.localStorage.getItem("access-token"),
                                useWebSockets: true,
                                authenticationId,
                                requestId,
                            },
                        }
                    );
                };

                const uuid = crypto.randomUUID();
                this.callbacks[uuid] = onResponse;
                this.createInitialPrivateWebsocket();
            } catch (e) {
                console.log(e);
                resolve({ error: e.message });
            }
        });
    }

    async callAsync(functionName, parameters) {
        return new Promise(async (resolve) => {
            try {
                const requestId = crypto.randomUUID();
                const authenticationId =
                    window.localStorage.getItem("authenticationId");

                if (!authenticationId) {
                    resolve(null);
                    return;
                }

                await this.validateSign();

                const onResponse = () => {
                    SocketHelper.onResponse(
                        functionName,
                        requestId,
                        (results) => {
                            resolve(results);
                        }
                    );

                    Axios.post(
                        localRoute,
                        {
                            serviceName: functionName,
                            parameters,
                        },
                        {
                            headers: {
                                "x-access-token":
                                    window.localStorage.getItem("access-token"),
                                useWebSockets: true,
                                authenticationId,
                                requestId,
                            },
                        }
                    );
                };

                const uuid = crypto.randomUUID();
                this.callbacks[uuid] = onResponse;
                this.createInitialPrivateWebsocket();
            } catch (e) {
                console.log(e);
            }
        });
    }

    async callAsyncPublic(functionName, parameters) {
        try {
            return new Promise(async (resolve) => {
                try {
                    const requestId = crypto.randomUUID();

                    const onResponse = () => {
                        SocketHelper.onResponse(
                            functionName,
                            requestId,
                            resolve
                        );

                        Axios.post(
                            "/public",
                            {
                                serviceName: functionName,
                                parameters,
                            },
                            {
                                headers: {
                                    useWebSockets: true,
                                    requestId,
                                    nonce,
                                },
                            }
                        );
                    };

                    const uuid = crypto.randomUUID();
                    this.publicCallbacks[uuid] = onResponse;
                    this.createInitialPublicWebsocket();
                } catch (e) {
                    console.log(e);
                    resolve({ error: e.message });
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    async callPublic(functionName, parameters, callback) {
        try {
            const requestId = crypto.randomUUID();

            return new Promise((resolve) => {
                try {
                    const onResponse = () => {
                        SocketHelper.onResponse(
                            functionName,
                            requestId,
                            (results) => {
                                if (callback) callback(results);
                                resolve(results);
                            }
                        );

                        Axios.post(
                            "/public",
                            {
                                serviceName: functionName,
                                parameters,
                            },
                            {
                                headers: {
                                    useWebSockets: true,
                                    requestId,
                                    nonce,
                                },
                            }
                        );
                    };

                    const uuid = crypto.randomUUID();
                    this.publicCallbacks[uuid] = onResponse;
                    this.createInitialPublicWebsocket();
                } catch (error) {
                    console.log(error);
                    resolve(null);
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    async callPublicRoute(route, parameters, callback) {
        try {
            const results = await Axios.post(route, parameters);
            if (callback) {
                callback(results);
            }
            return results;
        } catch (e) {
            console.log(e);
        }
    }

    async getPublicRoute(route, callback) {
        try {
            const results = await Axios.get(route);
            if (callback) {
                callback(results);
            }
            return results;
        } catch (e) {
            console.log(e);
        }
    }

    async sign() {
        try {
            const authenticationId =
                window.localStorage.getItem("authenticationId");

            if (!authenticationId) return;

            const response = await Axios.get("/private/sign", {
                headers: {
                    "authentication-token":
                        window.localStorage.getItem("authenticationId"),
                },
            });

            if (response && response.data && response.data.token) {
                const data = response.data;
                window.localStorage.setItem("access-token", data.token);
                cookies.set("access-token-expiration", true, {
                    path: "/",
                    expires: new Date(Date.now() + data.expirationMilli),
                });
            }

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async validateSign() {
        try {
            const accessExpiration = cookies.get("access-token-expiration");

            if (!accessExpiration) {
                return await this.sign();
            }

            return null;
        } catch (e) {
            console.log(e);
        }
    }

    getSessionId() {
        return window.sessionStorage.getItem("sessionId");
    }

    // after enqueuing REST calls, connection is attempted via WebSocket
    async createInitialPrivateWebsocket() {
        const authenticationId =
            window.localStorage.getItem("authenticationId");

        if (!authenticationId) return;

        // semiphore-like switches that limits to one connection for Private layer
        if (
            callingPrivateWebsocketPing ||
            SocketHelper.checkPrivateConnected()
        ) {
            if (!SocketHelper.checkPrivateConnected()) return;

            this.callQueue(this.callbacks);

            return;
        }

        callingPrivateWebsocketPing = true;

        try {
            let intervalId = null;

            const socketConnection = SocketHelper.createPrivateConnection(
                authenticationId,
                () => {
                    SocketHelper.setPrivateConnected(true);
                    callingPrivateWebsocketPing = false;
                    clearInterval(intervalId);

                    this.callQueue(this.callbacks);
                }
            );

            // client initiates handshake with server
            try {
                let tries = 0;

                intervalId = setInterval(function ping() {
                    try {
                        if (websocketRetryLimit === tries) {
                            console.log(
                                "Unable to establish websocket connection"
                            );
                            clearInterval(intervalId);
                            return;
                        }

                        socketConnection.send("ping");

                        tries++;
                    } catch (e) {
                        tries++;
                    }
                }, websocketPingDurration);
            } catch (e) {
                console.log(e);
            }
        } catch (e) {
            console.log(e);
        }
    }

    createInitialPublicWebsocket() {
        if (callingPublicWebsocketPing || SocketHelper.checkPublicConnected()) {
            if (!SocketHelper.checkPublicConnected()) return;

            this.callQueue(this.publicCallbacks);
            return;
        }

        callingPublicWebsocketPing = true;

        return new Promise((resolve) => {
            try {
                let intervalId = null;

                const socketConnection = SocketHelper.createPublicConnection(
                    nonce,
                    () => {
                        SocketHelper.setPublicConnected(true);
                        callingPublicWebsocketPing = false;
                        clearInterval(intervalId);

                        this.callQueue(this.publicCallbacks);

                        resolve("connected");
                    }
                );

                try {
                    let tries = 0;

                    intervalId = setInterval(function ping() {
                        try {
                            if (websocketRetryLimit === tries) {
                                console.log(
                                    "Unable to establish websocket connection"
                                );
                                clearInterval(intervalId);
                                resolve({
                                    error: "Unable to establish websocket connection",
                                });
                                return;
                            }

                            socketConnection.send("ping");

                            tries++;
                        } catch (e) {
                            tries++;
                        }
                    }, websocketPingDurration);
                } catch (e) {
                    console.log(e);
                }
            } catch (e) {
                console.log(e);
                resolve({ error: e.message });
            }
        });
    }

    // calls all enqueued REST calls after
    // WebSocket connection is established
    callQueue(callbacks) {
        try {
            const queue = Object.keys(callbacks);

            for (let i = 0; i < queue.length; i++) {
                const uuid = queue[i];
                callbacks[uuid]("connected");
                delete callbacks[uuid];
            }
        } catch (e) {
            console.log(e);
        }
    }
}

export default new Express();
